// Message plugin - 适配 Element UI 的 $message API
// 使用已安装的 vue-toastification 实现
import Vue from 'vue'

export default {
  install(Vue) {
    const toast = Vue.prototype.$toast
    
    Vue.prototype.$message = {
      success(message) {
        toast.success(message)
      },
      error(message) {
        toast.error(message)
      },
      warning(message) {
        toast.warning(message)
      },
      info(message) {
        toast.info(message)
      }
    }
    
    // 支持简写形式: this.$message('默认消息')
    Vue.prototype.$message._ = function(message) {
      toast.info(message)
    }
  }
}

// 导出独立函数供非组件使用
export function showMessage({ type = 'info', message }) {
  const toast = Vue.prototype.$toast
  if (toast && toast[type]) {
    toast[type](message)
  } else {
    console.warn(`Toast type "${type}" not supported`)
  }
}

